<script setup lang="ts">

</script>

<template>
    <v-chip
        variant="flat"
        color="#FBC9C2"
        size="x-small"
        class="text-red-darken-4 ml-2 px-2 text-caption"
    >
        Closed
    </v-chip>
</template>

<style scoped>

</style>
